export default __webpack_public_path__ + "static/media/img6.e36e9b4b.png";